import script from "./BotMessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./BotMessageList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BotMessage from "@/components/catering/bottleBot/BotMessage.vue";
import BotTyping from "@/components/catering/bottleBot/BotTyping.vue";
script.components = Object.assign({}, { BotMessage, BotTyping }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BotMessage, BotTyping }, script.__o.components);}